import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

const Footer = ({ loggedIn }) => {
  return (
    <div className="footer">
      <div>Contact: info@bonobohope.org</div>
      <div>
        <ul>
          <li>
            <Link to="/Donate" className="link">
              Donate to BHI
            </Link>
          </li>
        </ul>
      </div>
      <div className="footer-copyright">
        © 2013-2025 Bonobo Hope Initiative
        <Link to="/privacy-policy" className="link privacy-policy-link">
          Privacy Policy
        </Link>
      </div>
    </div>
  );
};

export default Footer;
